import React from "react"

import Box, { BoxProps } from "@mui/material/Box"
import { TooltipProps } from "@mui/material/Tooltip"

import { BasicTooltip } from "./BasicTooltip"

export type TooltipWithChildrenContainerProps = Omit<TooltipProps, "children"> & {
  children: any
  childrenContainerProps?: BoxProps
}

export const TooltipWithChildrenContainer = ({ children, childrenContainerProps, ...props }: TooltipWithChildrenContainerProps) =>
  <BasicTooltip {...props}>
    <Box component="span" className="Tooltip-childrenContainer" {...childrenContainerProps}>
      {children}
    </Box>
  </BasicTooltip>
